import React, { useState, useEffect, useCallback, useRef } from 'react';
import RelativeSvgLoader from '../common/components/RelativeSvgLoader';
import '../styles/News.css';

// Mock data for now - this would be replaced with actual API call
const mockNewsData = [
    {
        id: 1,
        title: "System Maintenance Scheduled",
        content: "We will be performing critical system maintenance on November 10th from 2:00 AM to 4:00 AM EST to upgrade our server infrastructure and enhance security protocols. During this time, the CMS platform may be temporarily unavailable. We recommend saving any pending work before the maintenance window. This upgrade will improve system performance by 40% and includes new security features to protect your data. Emergency support will remain available via phone during the maintenance period. We apologize for any inconvenience and appreciate your understanding as we work to provide you with a better, more secure platform.",
        date: "2025-11-01",
        author: "System Administrator"
    },
    {
        id: 2,
        title: "New Enhanced Product Management Features Released",
        content: "We're excited to announce the release of our latest product management features that will revolutionize how you manage your inventory. The new update includes intelligent pagination with dynamic loading, advanced filtering capabilities, improved bulk editing tools, and a redesigned product grid that displays more information at a glance. The enhanced search functionality now supports partial matches, category filtering, and advanced sorting options. Additionally, we've introduced automatic inventory tracking, low-stock alerts, and batch operations for updating multiple products simultaneously. These improvements are based on extensive user feedback and will significantly reduce the time spent on product management tasks.",
        date: "2025-10-28",
        author: "Product Development Team"
    },
    {
        id: 3,
        title: "Critical Security Update - Action Required",
        content: "Important security patches have been successfully applied to enhance system protection against the latest cyber threats. This update addresses potential vulnerabilities in user authentication, data encryption, and API access controls. All user sessions have been refreshed, and we strongly recommend that all users log out and log back in to ensure they benefit from the new security measures. We've also implemented two-factor authentication options, enhanced password requirements, and improved session management. Your data security is our top priority, and these measures ensure your business information remains protected. Please update your passwords if you haven't done so in the last 90 days.",
        date: "2025-10-25",
        author: "Security Team"
    },
    {
        id: 4,
        title: "Holiday Schedule and Support Availability",
        content: "Please note our holiday schedule for the upcoming Thanksgiving period. Our support team will have limited availability on November 28th and 29th due to the Thanksgiving holidays. Emergency support will be available 24/7 for critical issues, but response times for general inquiries may be extended. We'll resume normal support hours on December 2nd. During this period, our self-service resources, knowledge base, and video tutorials will remain fully accessible. We recommend checking our FAQ section for common issues. For urgent matters, please use the priority support channel in your dashboard. We wish you and your families a wonderful Thanksgiving celebration!",
        date: "2025-10-20",
        author: "Support Operations Manager"
    },
    {
        id: 5,
        title: "Major Performance Improvements Deployed",
        content: "We've completed a comprehensive performance optimization project that has resulted in significant improvements across the entire platform. Database queries have been optimized and now run 60% faster, page load times have been reduced by an average of 3.2 seconds, and overall system responsiveness has improved dramatically. The improvements include upgraded server infrastructure, optimized database indexing, enhanced caching mechanisms, and streamlined code architecture. Large inventory operations that previously took minutes now complete in seconds. Image loading has been optimized with lazy loading and compression, while the dashboard now loads instantly. These enhancements will be particularly noticeable during peak usage hours and when managing large product catalogs.",
        date: "2025-10-15",
        author: "Development Team"
    },
    {
        id: 6,
        title: "New Product Category System and Organization Tools",
        content: "We've introduced an advanced product categorization system that allows for more granular organization of your inventory. The new system supports unlimited category levels, custom attributes per category, and intelligent auto-categorization based on product descriptions. You can now create custom category hierarchies, assign multiple categories to products, and use advanced filtering based on category combinations. The system includes bulk category assignment tools, category-based pricing rules, and automated inventory reports by category. Migration tools are available to help transition existing products to the new category structure. This update also includes improved category-based SEO optimization and enhanced reporting capabilities for better business insights.",
        date: "2025-10-10",
        author: "Product Manager"
    },
    {
        id: 7,
        title: "Enhanced Backup and Data Protection Policy",
        content: "Our commitment to data protection has been strengthened with significant improvements to our backup and recovery systems. We've increased backup frequency to every 6 hours (previously 24 hours), implemented real-time data replication across multiple geographic locations, and added point-in-time recovery capabilities. The new system includes automated backup verification, encrypted storage with military-grade security, and 99.99% data recovery guarantee. In addition to regular backups, we now offer on-demand backup creation before major updates or bulk operations. Disaster recovery testing is performed monthly, and recovery time objectives have been reduced to under 30 minutes for critical systems. Your data is now more secure than ever with these enterprise-grade protection measures.",
        date: "2025-10-05",
        author: "Data Protection Officer"
    },
    {
        id: 8,
        title: "Mobile CMS Application Development Update",
        content: "We're thrilled to share exciting progress on our upcoming mobile CMS application that will bring full content management capabilities to your smartphone and tablet. The mobile app will feature complete product management, order processing, inventory tracking, and real-time analytics all optimized for mobile devices. Key features include offline capability for basic operations, push notifications for important updates, biometric authentication, and a intuitive touch-friendly interface. Beta testing will begin in December 2025 with select customers, followed by public release in Q1 2026. The app will support both iOS and Android platforms and will sync seamlessly with your existing CMS data. Early preview screenshots and feature demonstrations will be available in our next update.",
        date: "2025-10-01",
        author: "Mobile Development Team"
    },
    {
        id: 9,
        title: "Major Database Infrastructure Migration Successfully Completed",
        content: "We've successfully completed a major database infrastructure migration to state-of-the-art cloud servers, resulting in unprecedented performance and reliability improvements. The new infrastructure features distributed database architecture, automatic scaling capabilities, and enhanced fault tolerance with 99.9% uptime guarantee. This migration enables faster query processing, improved concurrent user support, and better data consistency across all operations. The new system can handle 10x more simultaneous users and processes complex operations 5x faster than the previous infrastructure. Additionally, we've implemented advanced monitoring and alerting systems to proactively identify and resolve any potential issues before they impact your experience. All data integrity has been verified and no data loss occurred during the migration process.",
        date: "2025-09-25",
        author: "Infrastructure Team"
    },
    {
        id: 10,
        title: "Advanced Customer Support System Launch",
        content: "Our new advanced customer support system is now live, featuring AI-powered ticket routing, integrated video support, and comprehensive self-service options. The enhanced system includes intelligent issue categorization, priority-based routing to specialized support agents, and real-time chat support with screen sharing capabilities. Customers can now track support tickets in real-time, access video tutorials directly from support requests, and receive proactive notifications about issue resolution. The system also features a comprehensive knowledge base with searchable articles, video guides, and step-by-step tutorials. Average response times have been reduced by 70%, and customer satisfaction scores have increased significantly with these improvements.",
        date: "2025-09-20",
        author: "Customer Success Team"
    },
    {
        id: 11,
        title: "Advanced Analytics Dashboard with Business Intelligence",
        content: "The new analytics dashboard has been completely redesigned with advanced business intelligence features that provide deep insights into your business performance. New features include predictive analytics for sales forecasting, customer behavior analysis, inventory optimization recommendations, and profitability analysis by product category. The dashboard now offers customizable widgets, automated report generation, and data export capabilities in multiple formats. Advanced visualizations include heat maps, trend analysis, comparative charts, and real-time performance metrics. Machine learning algorithms analyze your data patterns to provide actionable insights and recommendations for business growth. Integration with popular business tools and the ability to create custom dashboards for different user roles make this a powerful tool for data-driven decision making.",
        date: "2025-09-15",
        author: "Analytics Team"
    },
    {
        id: 12,
        title: "API Infrastructure Upgrade and Integration Enhancements",
        content: "We've significantly upgraded our API infrastructure to support growing integration demands and provide better developer experience. API rate limits have been increased by 300%, response times improved by 50%, and we've added comprehensive webhook support for real-time data synchronization. The new API documentation includes interactive testing tools, code examples in multiple programming languages, and detailed integration guides. Enhanced security features include API key management, OAuth 2.0 support, and granular permission controls. We've also introduced GraphQL endpoints for more efficient data querying and bulk operation capabilities for high-volume integrations. These improvements enable seamless integration with e-commerce platforms, accounting software, and third-party business tools while maintaining the highest security standards.",
        date: "2025-09-10",
        author: "API Development Team"
    }
];

function News() {
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [newsData, setNewsData] = useState([]);
    const [hasMoreData, setHasMoreData] = useState(true);
    const [expandedItems, setExpandedItems] = useState(new Set());
    const observerRef = useRef();
    
    const pageSize = 5; // Load 5 news items per request
    const maxCharacters = 100; // Maximum characters before truncation

    const fetchNewsData = useCallback(async (page, reset = false) => {
        if (reset) {
            setIsLoading(true);
        } else {
            setIsLoadingMore(true);
        }
        
        try {
            // Simulate API delay
            await new Promise(resolve => setTimeout(resolve, 800));
            
            // Calculate pagination
            const startIndex = (page - 1) * pageSize;
            const endIndex = startIndex + pageSize;
            const newData = mockNewsData.slice(startIndex, endIndex);
            
            if (reset) {
                setNewsData(newData);
            } else {
                setNewsData(prev => [...prev, ...newData]);
            }
            
            // Check if there's more data
            setHasMoreData(endIndex < mockNewsData.length);
        } catch (error) {
            console.error("Error fetching news data:", error);
        } finally {
            setIsLoading(false);
            setIsLoadingMore(false);
        }
    }, [pageSize]);

    // Initial load
    useEffect(() => {
        fetchNewsData(1, true);
    }, [fetchNewsData]);

    // Intersection Observer for infinite scroll
    const lastNewsElementRef = useCallback(node => {
        if (isLoadingMore) return;
        if (observerRef.current) observerRef.current.disconnect();
        
        observerRef.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMoreData && !isLoadingMore) {
                // Calculate next page based on current data length
                const nextPage = Math.floor(newsData.length / pageSize) + 1;
                fetchNewsData(nextPage, false);
            }
        });
        
        if (node) observerRef.current.observe(node);
    }, [isLoadingMore, hasMoreData, fetchNewsData, newsData.length, pageSize]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const toggleExpanded = (itemId) => {
        setExpandedItems(prev => {
            const newSet = new Set(prev);
            if (newSet.has(itemId)) {
                newSet.delete(itemId);
            } else {
                newSet.add(itemId);
            }
            return newSet;
        });
    };

    const truncateText = (text, itemId) => {
        if (text.length <= maxCharacters) {
            return text;
        }
        
        const isExpanded = expandedItems.has(itemId);
        if (isExpanded) {
            return text;
        }
        
        return text.substring(0, maxCharacters) + '...';
    };

    return (
        <div className="news-container">
            {isLoading && <RelativeSvgLoader />}
            <div className="news-content" style={{ opacity: isLoading ? 0.3 : 1 }}>
                {newsData.length === 0 && !isLoading ? (
                    <div className="no-news">
                        <p>No news updates available at this time.</p>
                    </div>
                ) : (
                    <div className="news-list">
                        {newsData.map((newsItem, index) => (
                            <div 
                                key={newsItem.id} 
                                className="news-item"
                                ref={index === newsData.length - 1 ? lastNewsElementRef : null}
                            >
                                <div className="news-header">
                                    <h3 className="news-item-title">{newsItem.title}</h3>
                                    <div className="news-meta">
                                        <span className="news-date">{formatDate(newsItem.date)}</span>
                                        <span className="news-author">by {newsItem.author}</span>
                                    </div>
                                </div>
                                <div className="news-body">
                                    <p className="news-content">
                                        {truncateText(newsItem.content, newsItem.id)}
                                        {newsItem.content.length > maxCharacters && (
                                            <button 
                                                className="expand-button"
                                                onClick={() => toggleExpanded(newsItem.id)}
                                            >
                                                {expandedItems.has(newsItem.id) ? ' Show Less' : ' Read More'}
                                            </button>
                                        )}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Loading indicator for infinite scroll */}
                {isLoadingMore && (
                    <div className="loading-more">
                        <div className="loading-spinner"></div>
                        <span>Loading more news...</span>
                    </div>
                )}

                {/* End of data indicator */}
                {!hasMoreData && newsData.length > 0 && (
                    <div className="end-of-data">
                        <span>You've reached the end of the news feed</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default News;